import React from 'react'
import AddProductsForm from '../AddProductsForm'
import InputStatus from '../child/InputStatus'

const AddProduct = () => {
    return (
        <div className="row gy-4">
            <AddProductsForm />
        </div>

    )
}

export default AddProduct;